










































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import {
  SectorsApi, MarketsApi, SettingsApi, Sector, Market, Settings,
} from '@compassdigital/foodworks.ts.sdk';
import SystemModule from '@/store/modules/system';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import ConfigurationModal from '@/components/Modal/ConfigurationModal/index.vue';
import ConfigurationList from '@/components/Form/Configuration/ConfigurationList/index.vue';
import AppModule from '@/store/modules/app';

@Component({
  components: {
    TextButton,
    ConfigurationModal,
    ConfigurationList,
    PrimaryButton,
  },
})
export default class ConfigurationAdd extends Vue {
  @Prop({}) documentHeadline!: string;

  @Prop({}) label!: string;

  @PropSync('listArray', {}) list!: any;

  public dialog: boolean = false;

  private isOpen: boolean = false;

  public edit: boolean = false;

  private valid: boolean = true;

  public loading: boolean = false;

  public configurationValue: any = {
    name: '',
    cuisineTypes: '',
    deleted: false,
  };

  public onButtonClick() {
    this.dialog = true;
  }

  public close() {
    this.dialog = false;
  }

  public async onSubmitConfigure(label: string) {
    if ((this.$refs.form as any).validate()) {
      if (this.label === 'Sector') {
        try {
          this.loading = true;
          const api = new SectorsApi(AppModule.apiConfig);
          await api.createSector(this.configurationValue);
          await SystemModule.fetchSectors();
          this.list = SystemModule.sectors;
          this.dialog = false;
        } catch (error) {
          console.log('error', error);
        }
        this.loading = false;
      }
      if (this.label === 'Market') {
        try {
          this.loading = true;
          const api = new MarketsApi(AppModule.apiConfig);
          await api.createMarket(this.configurationValue);
          await SystemModule.fetchMarkets();
          this.list = SystemModule.markets;
          this.dialog = false;
        } catch (error) {
          console.log('error', error);
        }
        this.loading = false;
      }
      if (this.label === 'Cuisines') {
        try {
          this.loading = true;
          const arrayCuisines: any = {
            cuisineTypes: [],
          };
          if (this.list) {
            this.list.map((value:any) => arrayCuisines.cuisineTypes.push(value));
          }
          arrayCuisines.cuisineTypes.push(this.configurationValue.cuisineTypes);
          const api = new SettingsApi(AppModule.apiConfig);
          const data = await api.patchSettings(arrayCuisines);
          this.getCuisines();
          this.dialog = false;
        } catch (error) {
          console.log('error', error);
        }
        this.loading = false;
      }
    }
  }

  public async getCuisines() {
    const api = new SettingsApi(AppModule.apiConfig);
    const cuisine: any = await api.getSettings();
    const { cuisineTypes } = cuisine.data;
    const cuisinesArrays = cuisineTypes.sort((a:any, b:any) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
    this.list = cuisinesArrays;
  }

  public onSave() {
    this.$emit('done');
  }
}
